import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../constants";
import { getLookupsByValue } from "../services/lookupService";

export const useFetchLookupsByValue = (value, searchTerm = null) => {  
    console.log(`${value} received`)
    const { data = [], isLoading } = useQuery({
        queryKey: [queryKeys.lookups, value, searchTerm],
        queryFn: () => getLookupsByValue(value, searchTerm),
        enabled: !!value
    })
  
    return { data, isLoading };
  };